import i18next from 'i18next';

i18next.addResources('es', 'GeneralDataTableTitles', {
  interveners: 'Intervinientes',
  vinculatedFiles: 'Incidentes'
});
